import { render, staticRenderFns } from "./PlantBreadcrumb.vue?vue&type=template&id=58e924cc&scoped=true&"
import script from "./PlantBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./PlantBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./PlantBreadcrumb.vue?vue&type=style&index=0&id=58e924cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e924cc",
  null
  
)

export default component.exports